import { createReducer } from '@reduxjs/toolkit';
import { getArticle } from '../actions/getArticle';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getArticle.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  })).addCase(getArticle.pending, (state) => ({
    ...state,
    loading: true,
  })).addCase(getArticle.rejected, (state) => ({
    ...state,
    loading: false,
  }));
});
